module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Grid List Widget */

(function(fox) {

	fox.registerWidget('Tools_TabsSwitcher', {
		configure: function(options) {
			this.registerOptions('', {
				'targetWidget': '@parent',
				'event': 'click',
				'activeClass': 'active',
				'switchOnEmbed': false,
			});
			
			return this.callParent('configure', arguments);
		},

		init: function() {
			this._activeItem = false;
			this.ac = this.getOption('activeClass');
			this._vWidget = this.rwom1(this.requireOption('targetWidget'));

			this.items = false;
			this.addDomHandler({
				target: this.requireOption('target'),
				event: this.requireOption('event'),
				targetWidget: this._vWidget,
				callback: 'processEvent'
			}, 'main');

			if (this.getOption('callback')) {
				this.cb = fox.oop.createCallback(this.getOption('callback'), this);
			}

			if (this.getOption('switchOnEmbed') === true) {
				this.getEm().handleHook(this._vWidget, 'onStopRendering', this._switchOnEmbed.bind(this));
			}

			this.callParent('init', arguments);
		},

		_switchOnEmbed: function () {
			var node, itemId;

			if (this._activeItem) {
				if (fox.isString(this._activeItem)) {
					node = this._vWidget.dom1(this._activeItem);
				} else if (fox.dom.isDomNode(this._activeItem)) {
					itemId = this._activeItem.getAttribute('data-' + this.requireOption('name'));

					node = this._vWidget.dom1(['[data-', this.requireOption('name'), '="', itemId, '"]'].join(''));
				}

				this.switchElClass(node);
			}
		},

		deactivate: function () {
			this.items = false;
		
			this.callParent('deactivate', arguments);
		},

		getItems: function() {
			if (this.items === false) {
				this.items = this._vWidget.dom(this.requireOption('target'));
			}
			return this.items;
		},

		getActiveItem: function () {
			return this._vWidget.dom1(['.', this.ac].join(''))
		},

		switchElClass: function (el) {
			fox.dom.removeClass(this.ac, this.getActiveItem());
			fox.dom.addClass(this.ac, el);

			return this;
		},

		processEvent: function(el) {
			this.switchElClass(el);

			this._activeItem = el;

			var itemId = el.getAttribute('data-' + this.requireOption('name'));
			
			if (this.cb) {
				fox.oop.getRealCallback(this.cb)(itemId);
			}
		}

	}, 'Controller');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/tools/tabsSwitcher.js
// module id = 226
// module chunks = 0